// extracted by mini-css-extract-plugin
export var container = "layout-module--container--uTx4M";
export var pageObscurer = "layout-module--pageObscurer--zfPT8";